import React, { ReactNode } from 'react';
import css from './index.module.scss';
import csx from 'classnames';

type SpanProps = Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  'children'
>;

interface NavLinkProps extends SpanProps {
  children?: ReactNode;
  vertical?: boolean;
  isActive?: boolean;
}

export const NavLink = ({
  className,
  isActive,
  vertical,
  children,
  ...props
}: NavLinkProps) => (
  <span
    {...props}
    className={csx(className, css.container, {
      [css.vertical]: vertical,
      [css.horizontal]: !vertical,
      [css.active]: isActive,
    })}
  >
    {children}
  </span>
);
